import { DamageComplaintReportService } from '../services';
import { DamageComplaintReportConstants } from '../constants';
import { alertActions } from '.';

export const DamageComplaintReportActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());
        DamageComplaintReportService.fetchFeedbackData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: DamageComplaintReportConstants.GETALL_REQUEST } }
    function success(datas) { return { type: DamageComplaintReportConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: DamageComplaintReportConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: DamageComplaintReportConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        DamageComplaintReportService.fetchFeedbackData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { 
                    delete v.TotalRows; 
                    delete v.UserId; 
                    delete v.QRDamageImg; 
                });
            }
            dispatch(success(data));
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        });
    };

    function request() { return { type: DamageComplaintReportConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: DamageComplaintReportConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: DamageComplaintReportConstants.GETEXPORT_FAILURE, error } }
}


function loadingData(isbool) {
    return {
        type: DamageComplaintReportConstants.LOADING_REQUEST, isbool
    }
}
